






import Vue from 'vue'
import page from './page.vue'

export default Vue.extend({
  components: { page },
})
